/**
 * The portal's construction motif — a flat line-art hard hat, deliberately NOT a cartoon
 * character (Eric 7/2: "less cartoonish"). Variants restyle the same glyph:
 *   welcome — hat + rising sun arc        cheer — hat tips up, spark lines
 *   wait    — hat + slow drifting z's     sorry — hat tipped down, flat line
 * Gentle bob on `cheer` only (class motif-bob, killed by prefers-reduced-motion).
 */
export type MotifVariant = 'welcome' | 'cheer' | 'wait' | 'sorry';

export function Motif({ variant, size = 64, className }: { variant: MotifVariant; size?: number; className?: string }) {
  const tilt = variant === 'cheer' ? -8 : variant === 'sorry' ? 6 : 0;
  return (
    <svg
      className={`motif${variant === 'cheer' ? ' motif-bob' : ''}${className ? ` ${className}` : ''}`}
      width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true"
    >
      {variant === 'welcome' && (
        <path d="M10 22 A 22 22 0 0 1 54 22" stroke="var(--warn)" strokeWidth="2" strokeLinecap="round" strokeDasharray="3 5" />
      )}
      {variant === 'cheer' && (
        <g stroke="var(--gold)" strokeWidth="2" strokeLinecap="round">
          <path d="M12 20 L8 14" /><path d="M32 12 L32 5" /><path d="M52 20 L56 14" />
        </g>
      )}
      {variant === 'wait' && (
        <g fill="var(--muted)" fontFamily="var(--font-sans)" fontSize="9" opacity="0.7">
          <text x="46" y="18">z</text>
          <text x="52" y="11" fontSize="7">z</text>
        </g>
      )}
      <g transform={`rotate(${tilt} 32 40)`}>
        <path
          d="M14 44 C14 30 22 22 32 22 C42 22 50 30 50 44"
          fill="var(--warn)" stroke="var(--accent)" strokeWidth="2" strokeLinejoin="round"
        />
        <path d="M28 22.5 L28 34 M36 22.5 L36 34" stroke="var(--accent)" strokeWidth="1.6" opacity="0.55" />
        <rect x="29" y="17" width="6" height="7" rx="2" fill="var(--warn)" stroke="var(--accent)" strokeWidth="2" />
        <rect x="9" y="44" width="46" height="5" rx="2.5" fill="var(--gold)" stroke="var(--accent)" strokeWidth="2" />
      </g>
      {variant === 'sorry' && (
        <path d="M22 58 L42 58" stroke="var(--muted)" strokeWidth="2" strokeLinecap="round" />
      )}
    </svg>
  );
}
